// src/pages/PreviewDoc.jsx
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { authFetch } from "../services/auth";

export default function PreviewDoc() {
  const { id } = useParams();
  const [url, setUrl] = useState("");
  const [ctype, setCtype] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let revoked;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const res = await authFetch(`/api/documentos/${id}/download`);
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        const ct = res.headers.get("Content-Type") || "";
        setCtype(ct);
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        setUrl(blobUrl);
        revoked = blobUrl;
      } catch (e) {
        setErr(`No se pudo abrir el documento: ${e.message || e}`);
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [id]);

  if (loading) {
    return (
      <div className="p-6">
        <Link to="/" className="text-blue-600 hover:underline">← Volver</Link>
        <div className="mt-4 text-gray-600">Cargando documento…</div>
      </div>
    );
  }

  if (err) {
    return (
      <div className="p-6">
        <Link to="/" className="text-blue-600 hover:underline">← Volver</Link>
        <div className="mt-4 text-red-600">{err}</div>
      </div>
    );
  }

  const isPdf = ctype.includes("pdf");
  const isImage = ctype.startsWith("image/");
  const isText = ctype.startsWith("text/");

  return (
    <div className="p-4 h-screen flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Link to="/" className="text-blue-600 hover:underline">← Volver</Link>
        <a href={url} download className="px-3 py-2 rounded bg-blue-600 text-white hover:bg-blue-700">
          Descargar
        </a>
      </div>

      <div className="flex-1 border rounded overflow-hidden bg-white">
        {isPdf ? (
          <iframe title="PDF" src={url} className="w-full h-full" />
        ) : isImage ? (
          <img alt="Documento" src={url} className="w-full h-full object-contain" />
        ) : isText ? (
          <iframe title="Texto" src={url} className="w-full h-full" />
        ) : (
          <div className="p-6 text-gray-600">
            No hay visor embebido para este tipo ({ctype}). Usa “Descargar”.
          </div>
        )}
      </div>
    </div>
  );
}
